import convertStylesStringToObject from '../utils/convertStylesStringToObject';

type ListItemProps = Icon & {
  onClick?: (id: number) => void;
  customStyles?: string;
};

export const ListItem = ({ onClick, id, title, previewUrl, customStyles = '' }: ListItemProps) => {
  const handleOnClick = () => {
    if (onClick) {
      onClick(id);
    }
  };

  const styleString = `background-image: url(${previewUrl}); ${customStyles}`;

  return (
    <div
      className="icon-library--list-item flex flex-col content-center relative overflow-hidden p-1"
      data-icon-id={id}
      title={title}
    >
      <div
        className="icon-library--list-item--icon group cursor-pointer flex items-center justify-center relative transition-all w-24 h-24"
        onClick={handleOnClick}
      >
        <span
          className="icon-library--list-item--icon-bg bg-white h-12 opacity-0 absolute w-12 shadow-md transition duration-500 ease-in-out"
          aria-hidden="true"
        >
          &nbsp;
        </span>
        <div className="icon-library--list-item--icon-wrapper h-full overflow-hidden relative w-full p-4">
          <div
            className="icon-library--list-item--icon', `bg-center bg-no-repeat bg-contain h-full w-full"
            style={convertStylesStringToObject(styleString)}
          />
        </div>
      </div>
      <div className="icon-library--list-item--title absolute bottom-0 left-0 right-0 mb-1 overflow-hidden whitespace-nowrap overflow-ellipsis text-center font-sans text-xs">
        {title}
      </div>
    </div>
  );
};
